<template>
  <div class="section fp-auto-height-responsive" id="enterprise-section">
    <v-container>
      <v-row>
        <v-col cols="12" xl="8" offset-xl="2">
          <div class="section-contents top" ref="title">
            <h6>Value</h6>
            <h1><b>핀브릿지의</b><br />일하는 방식</h1>
            <p>우리는 실현 가능한 꿈을 가지고 새로운 가치를 만들고 있습니다. <br class="br" />앞으로 더 나은 서비스를 제공하기 위해 노력하는 핀브릿지가 되겠습니다.</p>
          </div>
          <v-row>
            <v-col cols="6" md="3">
              <div class="value value1">
                <img src="@/assets/new/image/company/company_icon_1.svg" alt="icon" />
                <p>자율을 뛰어넘는 <br />투명성</p>
              </div>
            </v-col>
            <v-col cols="6" md="3">
              <div class="value value2">
                <img src="@/assets/new/image/company/company_icon_2.svg" alt="icon" />
                <p>끈기 또는 <br />인내</p>
              </div>
            </v-col>
            <v-col cols="6" md="3">
              <div class="value value3">
                <img src="@/assets/new/image/company/company_icon_3.svg" alt="icon" />
                <p>천재 보다는 <br />팀워크</p>
              </div>
            </v-col>
            <v-col cols="6" md="3">
              <div class="value value4">
                <img src="@/assets/new/image/company/company_icon_4.svg" alt="icon" />
                <p>새로운 것을 <br />익숙한 것으로</p>
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import { gsap } from "gsap";

const { mapGetters } = createNamespacedHelpers("ui");

export default {
  name: "EnterpriseValue",
  computed: {
    ...mapGetters(["sectionNumber"])
  },
  watch: {
    sectionNumber() {
      const { title } = this.$refs;

      if (this.sectionNumber === 1) {
        gsap.to(title, .5, { opacity: 1, y: 0 })
        gsap.to(".value1", .4, { delay: .3, opacity: 1, y: 0 })
        gsap.to(".value2", .4, { delay: .5, opacity: 1, y: 0 })
        gsap.to(".value3", .4, { delay: .7, opacity: 1, y: 0 })
        gsap.to(".value4", .4, { delay: .9, opacity: 1, y: 0 });
      }
    }
  }
};
</script>
